import axios from 'axios';
import * as utils from '../../scripts/utils/formDataToJson';

class RedeemPoints extends HTMLElement {
  constructor() {
    super();

    this.member = false;
    this.redeemPoints = 0;
    if (this.querySelector('[data-form]')) {
      this.connectedFormName = this.querySelector('[data-form]').getAttribute('data-form');
    }
    this.connectedForm = this.closest('c-drawer').querySelector(`form[name="${this.connectedFormName}"]`);

    this.successMessage = this.querySelector('[data-message-success]');
    this.errorMessage = this.querySelector('[data-message-error]');
    this.memberPoints = this.querySelector('[data-club-points]');

    this.inputs = {
      points: 'points',
      submit: 'redeem-points-submit',
    };

    this.pointsInput = this.querySelector(`input[name=${this.inputs.points}]`);
    this.submitButton = this.querySelector(`button[name=${this.inputs.submit}`);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (!this.pointsInput || !this.submitButton || !this.connectedForm) {
      return;
    }

    this.pointsInput.removeEventListener('keyup', this.handleInputChange);
    this.submitButton.removeEventListener('click', this.triggerSubmitConnectedForm);
    this.connectedForm.removeEventListener('submit', this.handleSubmitConnectedForm);
  }

  setRedeemPoints(points) {
    this.redeemPoints = points;
  }

  getRedeemPoints() {
    return this.redeemPoints;
  }

  async getMember() {
    return await Shopify.functions.getMember();
  }

  async getMemberFromStorage() {
    return await Shopify.functions.getMemberFromStorage();
  }

  async init() {
    this.member = await this.getMemberFromStorage();

    this.handleSection();
    this.addEvents();
  }

  handleSection() {
    Shopify.functions.showMemberSections(this.member, this);
    if (this.member) {
      this.pointsInput.setAttribute('max', parseFloat(this.member.points));
      this.memberPoints.textContent = this.member.points;
    }
  }

  addEvents() {
    if (this.pointsInput && this.submitButton && this.connectedForm) {
      this.pointsInput.addEventListener('keyup', this.handleInputChange.bind(this));
      this.submitButton.addEventListener('click', this.triggerSubmitConnectedForm.bind(this));
      this.connectedForm.addEventListener('submit', this.handleSubmitConnectedForm.bind(this));
    }
  }

  handleInputChange(ev) {
    const thisInput = ev.target;

    if (parseFloat(thisInput.value) > parseFloat(thisInput.getAttribute('max'))) {
      thisInput.value = thisInput.getAttribute('max');
    }

    if (parseFloat(thisInput.value) < 1) {
      this.submitButton.disabled = true;
    } else {
      this.submitButton.disabled = false;
    }

    this.setRedeemPoints(thisInput.value);
    this.connectedForm.querySelector(`input[name=${this.inputs.points}]`).value = this.getRedeemPoints();
  }

  triggerSubmitConnectedForm(ev) {
    ev.preventDefault();

    this.querySelectorAll('input, button').forEach((input) => {
      input.disabled = true;
    });

    this.connectedForm.dispatchEvent(new Event('submit'));
  }

  handleSubmitConnectedForm(ev) {
    ev.preventDefault();
    this.sendData();
  }

  async sendData() {
    const form = this.connectedForm;
    const formData = new FormData(form);
    const jsonData = utils.formDataToJson(formData);

    // return if the form is empty
    if (formData.entries().next().done) return;
    this.successMessage.classList.add('hidden');
    this.errorMessage.classList.add('hidden');

    const points = jsonData.points;
    if (!points) {
      this.errorMessage.classList.remove('hidden');
      return;
    }

    this.submitButton.querySelector("[data-default]").classList.add('hidden');
    this.submitButton.querySelector("[data-progress]").classList.remove('hidden');

    try {
      const url = 'http://intersportapi.netlify.app/.netlify/functions/redeemPoints';
      const resp = await axios.post(url, jsonData);

      const discountCode = await resp?.data?.data?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount?.codes?.nodes[0]?.code;
      const appliedDiscountCode = await Shopify.functions.applyDiscountCode(discountCode);
      if (this.successMessage.querySelector('[data-points]')) {
        this.successMessage.querySelector('[data-points]').textContent = appliedDiscountCode;
      }

      this.successMessage.classList.remove('hidden');
      this.errorMessage.classList.add('hidden');
      this.submitButton.querySelector("[data-success]").classList.remove('hidden');
      this.submitButton.querySelector("[data-progress]").classList.add('hidden');

      const newMember = await this.getMember();
      this.memberPoints.textContent = newMember.points;

    } catch (error) {
      console.log('🚀 ~ error:', error);

      this.submitButton.querySelector("[data-progress]").classList.add('hidden');
      this.successMessage.classList.add('hidden');
      this.errorMessage.classList.remove('hidden');
    }

    setTimeout(() => {
      this.submitButton.querySelector("[data-success]").classList.add('hidden');
      this.submitButton.querySelector("[data-default]").classList.remove('hidden');

      this.querySelectorAll('input, button').forEach((input) => {
        input.disabled = false;
      });
      this.pointsInput.value = '';
      this.connectedForm.reset();
    }, 1500);
  }
}

customElements.define('redeem-points', RedeemPoints);
